import { Card, Row, Col } from "react-bootstrap";
import { useClientSummaryData } from "../hooks/ClientSummaryContext";
import Skeleton from "react-loading-skeleton";
import { useClientContext } from "../../../hooks/ClientContext";
import useOpenMasterAccount from "../../../hooks/useOpenMasterAccount";

function ClientSummaryDetails() {
    const { data, error, isLoading } = useClientSummaryData();
    const { id: masterAccountId } = useClientContext();
    const openMasterAccount = useOpenMasterAccount();

    if (isLoading) return (
        <Skeleton height={300} />
    )

    if (error) return <p>Error loading data</p>;
    if (!data) {
        return null;
    }

    const handleOpenClientDetails = (e) => {
        e.preventDefault();
        openMasterAccount(masterAccountId, { suffix: "details" });
    };

    return (
        <>
            <Col className="col-4">
                <Card style={{ height: "auto", minHeight: "300px" }}>
                    <Card.Body>
                        <Card.Title style={{ fontSize: "22px", paddingBottom: "20px" }}>
                            <a className="text-reset text-decoration-none" href={`/client/${masterAccountId}/details`}
                                onClick={(e) => handleOpenClientDetails(e)}>Client Details</a>
                        </Card.Title>
                        <Card.Text>
                            {data.clientAccounts.map((item) => (
                                <Row key={item.id}>
                                    <Col className="col-6">
                                        <p className="fw-bold"> Name:</p>
                                    </Col>
                                    <Col className="col-sm-3 col-md-6">
                                        {item.title} {item.forenames} {item.surname} {data.isAMLExpired && (<span className="badge rounded-pill bg-danger px-2 py-1 fs-7">AML Expired</span>)} {data.isAMLMissing && (<span className="badge rounded-pill bg-danger px-2 py-1 fs-7">AML Missing</span>)}
                                    </Col>
                                </Row>
                            ))
                            }
                            {data.addresses.map((item) => (
                                <Row key={item.id}>
                                    <Col className="col-6">
                                        <p className="fw-bold"> Address:</p>
                                    </Col>
                                    <Col className="col-6">
                                        {item.address}, {item.postcode}
                                    </Col>
                                </Row>
                            ))
                            }
                            {data.contactDetails.map((item) => (
                                <Row key={item.id}>
                                    <Col className="col-6">
                                        <p className="fw-bold"> Contact:</p>
                                    </Col>
                                    <Col className="col-6">
                                        {item.isActive ? item.details : ""}
                                    </Col>
                                </Row>
                            ))
                            }
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </>
    )
}

export default ClientSummaryDetails;